const FACTORS_DATA = [
    {
      id: 1,
      title: 'WOW Comfy',
      data: 'Sit back, relax and enjoy! A movie experience like none other!',      
      imageUrl: 'sofa.png'
    },
    {
      id: 2,
      title: 'WOW XL',
      data: 'Enjoy the extra large WOW screen',      
      imageUrl: 'screen.png'
    },
    {
      id: 3,
      title: 'WOW Kids',
      data: 'One-of-its-kind, for the young ones!',      
      imageUrl: 'person.png'
    },
    {
      id: 4,
      title: 'WOW Gold/ Premium',
      data: 'The luxury place for your private parties and family get-togethers!',      
      imageUrl: 'star.png'
    },
    {
      id: 5,
      title: 'WOW Drive In',
      data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',      
      imageUrl: 'car.png'
    },
    {
      id: 6,
      title: 'WOW Sky',
      data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',      
      imageUrl: 'clouds.png'
    },
  ];
  
  export default FACTORS_DATA;
  